import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=4a779cdc&scoped=true"
import script from "./Title.vue?vue&type=script&lang=js"
export * from "./Title.vue?vue&type=script&lang=js"
import style0 from "./Title.vue?vue&type=style&index=0&id=4a779cdc&prod&scoped=true&lang=css"
import style1 from "./Title.vue?vue&type=style&index=1&id=4a779cdc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a779cdc",
  null
  
)

export default component.exports